module.exports = {"TXTCLI_Search_tournaments":{"id":"TXTCLI_Search_tournaments","defaultMessage":"Пошук турнірів","track":"Search tournaments"}}